import { connect } from 'react-redux'
import React, { Component } from 'react'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch,
  withRouter
} from "react-router-dom";
import { history } from '../helper/history'

import MetronicIndex from '../layout/metronic/index'
import MasterProfile from '../component/magent_profile'
import ChangePassword from '../component/change_password'
import MasterHome from '../component/magent_home'
import MasterHistoryCommision from '../component/magent_history_fee'
import MasterHistoryBonus from '../component/magent_history_bonus'
import MasterHistoryTx from '../component/magent_history_tx'
import MasterHistoryDeposit from '../component/magent_history_deposit'
import MAgentManageAgent from '../component/magent_manage_agent'
import MAgentManageCommision from '../component/magent_manage_commision'
import MAgentManageService from '../component/magent_manage_service'
import MAgentSettings from '../component/magent_settings'
import MasterCreateDownline from '../component/magent_create_new_downline'
import MasterCreateAgent from '../component/magent_create_new_agent'
import MasterDownloadAgent from '../component/magent_download_agent'
import MasterBatchKomisi from '../component/magent_batch_komisi'
import MasterBatchBonus from '../component/magent_batch_bonus'
import MasterBatchP2P from '../component/magent_batch_p2p'
import MAgentWorkstation from '../component/magent_workstation'
import Inbox from '../component/inbox'
import TopupVA from '../component/topup'
import ReportMonthly from '../component/magent_report_monthly'
import ReportDaily from '../component/magent_report_daily'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter} from '../component/widget/portlet'

import apis from '../helper/api'
import request from 'superagent'
import localdata from '../helper/localdata'
import config from '../helper/config'
import action from '../helper/action'
import do_action from '../action'
import util from '../helper/util'

const routes = [
    {
        path: "/master/home",
        component: MasterHome,
        exact : false
    },
    {
        path: "/master/profile",
        component: MasterProfile,
        exact : false
    },
    {
        path: "/master/report-monthly",
        component: ReportMonthly,
        exact : false
    },
    {
        path: "/master/report-daily",
        component: ReportDaily,
        exact : false
    },
    {
        path: "/master/change-password",
        component: ChangePassword,
        exact : false
    },
    {
        path: "/master/riwayat-fee",
        component: MasterHistoryCommision,
        exact : false
    },
    {
        path: "/master/riwayat-bonus",
        component: MasterHistoryBonus,
        exact : false
    },
    {
        path: "/master/riwayat-transaksi",
        component: MasterHistoryTx,
        exact : false
    },
    {
        path: "/master/riwayat-deposit",
        component: MasterHistoryDeposit,
        exact : false
    },
    {
        path: "/master/topup-va",
        component: TopupVA,
        exact : false
    },
    {
        path: "/master/inbox",
        component: Inbox,
        exact : false
    },
    {
        path: "/master/manage-agent",
        component: MAgentManageAgent,
        exact : false
    },
    {
        path: "/master/manage-commision",
        component: MAgentManageCommision,
        exact : false
    },
    {
        path: "/master/manage-service",
        component: MAgentManageService,
        exact : false
    },
    {
        path: "/master/manage-settings",
        component: MAgentSettings,
        exact : false
    },
    {
        path: "/master/create-agent",
        component: MasterCreateAgent,
        exact : false
    },
    {
        path: "/master/create-downline",
        component: MasterCreateDownline,
        exact : false
    },
    {
        path: "/master/download-agent",
        component: MasterDownloadAgent,
        exact : false
    },
    {
        path: "/master/batch-komisi",
        component: MasterBatchKomisi,
        exact : false
    },
    {
        path: "/master/batch-bonus",
        component: MasterBatchBonus,
        exact : false
    },
    {
        path: "/master/batch-p2p",
        component: MasterBatchP2P,
        exact : false
    },
    {
        path: "/master/manage-workstation",
        component: MAgentWorkstation,
        exact : false
    }
];

const SubRoutes = route => (
    <Route
        exact={route.exact}
        path={route.path}
        render={props => (
            <route.component {...props} routes={route.routes} />
        )}
    />
);

let task_schedule_counter = 0

class HomeMaster extends Component {
    constructor(props) {
        super(props)
        localdata.get_login_result().then((payload) => {
            util.log("data", payload)
            let valid = true
            if (payload.status == "OK") {
                if (payload.results) {
                    if (payload.results.session_id) {
                        this.props.update_session(payload.results.session_id)
                    } else {
                        valid = false
                    }
                    let p = {
                        userid : payload.results.user_id,
                        masterid: payload.results.master_id,
                        usertype : payload.results.user_type,
                        username : payload.results.username,
                        paymode : payload.results.paymode,
                        level : payload.results.level
                    }
                    if (payload.results.workstation_code) {
                        p.workstation_code = payload.results.workstation_code
                    }
                    if (payload.results.profile) {
                        let profile = payload.results.profile
                        let p2 = {
                            name : profile.fullname, 
                            email : profile.email,
                            photo : profile.photo_filename
                        }
                        if (profile.workstation_name.length !== 0) {
                            p2.workstation_name = profile.workstation_name
                        }
                        p = Object.assign({}, p, p2);
                    }
                    if (payload.results.bank_accounts) {
                        let banks = []
                        payload.results.bank_accounts.map(function(item, i) {
                            banks.push({"bank_name" : item.bank_name, "account_name" : item.account_name, "account_number" : item.account_number})
                        })
                        p = Object.assign({}, p, {"bank_accounts" : banks});
                    }
                    this.props.update_profile(p)
                    if (payload.results.list_balances) {
                        let deposits = payload.results.list_balances.deposits
                        util.log("deposit: ", deposits[0])
                        this.props.update_balance(deposits[0].balance_value)
                    }
                } else {
                    valid = false
                }
            } else {
                valid = false
            }
            if (!valid) {
                setTimeout(() => {
                    history.replace('/login')
                }, 500);
            } else {
                this.task()
                this.task_schedule()
            }
        }).catch((err) => {
            util.log("error : ", err)
            setTimeout(() => {
                history.replace('/login')
            }, 500);
        })
    }

    componentDidMount() {
        
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login');
            }).catch((err) => {
                util.log("error: ", err)
            })
        }
    }

    task_schedule() {
        let delay = 1 * 60 * 1000
        let self = this
        setTimeout(function() {
            task_schedule_counter++;
            util.log("task_schedule: " + new Date(), "counter: " + task_schedule_counter)
            self.task()
            self.task_schedule()
        }, delay);
    }

    task() {
        if (task_schedule_counter === 0 || task_schedule_counter % 15 === 0) {
            this.task_update_balance()
        }
            
    }

    task_update_balance() {
        util.log("task_update_balance")
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.balance_main)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("task_update_balance", err)
                } else {
                    util.log("task_update_balance", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results.list) {
                                let deposits = payload.results.list
                                util.log("deposit: ", deposits[0])
                                self.props.update_balance(deposits[0].balance_value)
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    }
                }
            });
    }

    render() {
        let title = this.props.location.pathname;
        return (
            <Router>
                <MetronicIndex  
                    url={this.props.location.pathname}>
                    <Switch>
                        {routes.map((route, i) => <SubRoutes key={i} {...route} />)}
                        <Route exact path='/master' component={MasterHome}/>
                        <Route path="*" component={MasterHome} />
                    </Switch>
                </MetronicIndex>
            </Router>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_session: val => dispatch(do_action(action.ACTION_UPDATE_USER_SESSION, val)),
    update_balance: val => dispatch(do_action(action.ACTION_UPDATE_USER_BALANCE, val)),
    update_profile: payload => dispatch(do_action(action.ACTION_UPDATE_USER_INFO, payload))
})

const mapStateToProps = (state) => ({
    session : state.Session
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeMaster)



// WEBPACK FOOTER //
// ./src/page/home_magent.js